/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Parameter_Change_In_EffectInputs */

const en_error_parameter_change_in_effect = /** @type {(inputs: Error_Parameter_Change_In_EffectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This value is already in force: set a new value instead.`)
};

/**
* | output |
* | --- |
* | "This value is already in force: set a new value instead." |
*
* @param {Error_Parameter_Change_In_EffectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_parameter_change_in_effect = /** @type {((inputs?: Error_Parameter_Change_In_EffectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Parameter_Change_In_EffectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_parameter_change_in_effect(inputs)
});